import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=128ca551&scoped=true&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/userprofile.css?vue&type=style&index=0&id=128ca551&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ca551",
  null
  
)

export default component.exports